<tmo-customer-authentication-modal
  *ngIf="showExistingCustomerModal"
  [aemContent]="pdpStaticContent"
  [displayModal]="showExistingCustomerModal"
  [productDetail]="productInfo"
  (closeModal)="closeCustomerModal()"
  (newCustomer)="setSelectedItemInPDP(deviceDetails)"
>
</tmo-customer-authentication-modal>
<ng-container *ngIf="deviceDetails" tmoGoToRepdashTop [goToTop]="true">
  <tmo-epin-conflict-modal
    *ngIf="epinConflictData?.hasConflict"
    [staticContent]="pdpStaticContent"
    [epinConflictData]="epinConflictData"
    [newSelectionName]="productFamilyName"
    [currentSelectionAmount]="selectedAmount"
    (addNewSelectionInCart)="addNewSelectionInCart()"
    (closeModal)="closeModal()"
    [isEpin]="isEpin"
  ></tmo-epin-conflict-modal>
  <div *ngIf="!showDeviceAddError">
    <p class="error-text m-t-md" tmoPdlError [errorText]="pdpStaticContent?.orderCompletionError">
      <i class="fa fa-exclamation-circle def error-icon m-t-md"></i
      >{{ pdpStaticContent?.orderCompletionError }}
    </p>
  </div>
  <div id="error-message-reason" class="m-t-lg" *ngIf="upgradeErrorMessage">
    <tmo-error-message-detail
      [errorMessage]="upgradeErrorMessage"
      pdlPageComponentId="ErrorDetailComponent"
    ></tmo-error-message-detail>
  </div>
  <tmo-device-details
    [deviceDetails]="deviceDetails"
    [selectedItem]="selectedItem"
    [pdpStaticContent]="pdpStaticContent"
    [colorOptions]="colorOptions"
    [cacheImages]="cacheImages || []"
    [pricingOptions]="pricingOptions"
    [memoryOptions]="memoryOptions"
    [isEpin]="isEpin"
    [isSimCard]="isSimCard"
    [selectedEipAmount]="selectedEpinAmount"
    [promotions]="promotions"
    (colorSelectionChange)="updateSelectedColor($event)"
    (memorySelectionChange)="updateSelectedMemory($event)"
    (simInfoSelectionChange)="updateSelectedSimInfo($event)"
    (certifiedDevice)="getCertifiedDevice($event)"
    (quantityChanged)="updateSelectedQuantity($event)"
    (isAvailable)="checkAvailability($event)"
    [isProductSelector]="false"
  >
    <!-- select a refil ammount dropdown -->

    <div class="row" *ngIf="isEpin" epinPriceDropdown>
      <div class="col-12 col-md-7 col-lg-6 m-t-lg">
        <tmo-dropdown
          [options]="pricingListDropdown"
          name="pdpStaticContent?.refillAmount"
          [placeholder]="pdpStaticContent?.selectRefillAmount"
          (selectionChange)="epinDetailsForSelectedAmount($event.val)"
          [id]="'tmo-dropdown-refill-amount-2'"
        ></tmo-dropdown>
      </div>
    </div>

    <!-- <div class="row" *ngIf="isSimCard && isAssistedFlow" displaySimcardSkus>
        <div class="col-12 col-md-7 m-t-sm" [class.m-b-md]="idx === itemDetails?.length - 1"  *ngFor="let simcard of itemDetails; let idx = index">
          <tmo-radio-button
            [id]="'tmo-radio-button-simcard_'+ idx"
            [selectedValue]="selectedItem?.id"
            [values]="simcard?.id"
            (onSelect)="handleSimRadioClickEvent(simcard?.id)"
            >{{simcard?.id}}</tmo-radio-button>
        </div>

      </div> -->
  </tmo-device-details>

  <div class="row">
    <div class="col-12 offset-sm-4 col-sm-8">
      <hr class="divider m-t-xl" *ngIf="!isEpin" />
      <div
        class="row"
        *ngIf="isProductTypeAccessory || isProductTypeFinancial; else displaySelectCta"
      >
        <div class="col-12 buttons-container-vertical button-spacing" [class.m-b-sm]="isEpin">
          <div class="button-box">
            <tmo-button
              [button]="addToCart"
              [disabled]="
                !isProductAvailable ||
                (isEpin && !selectedEpinAmount) ||
                (!isEpin && !isProductTypeAccessory) ||
                !showDeviceAddError ||
                disableCta
              "
              (onSelect)="addAccessoriesToCart(false)"
              id="tmo-button-add-to-cart"
              >{{ pdpStaticContent?.addToCart }}
            </tmo-button>
          </div>
          <div class="button-box">
            <tmo-button
              [button]="checkOut"
              [disabled]="
                !isProductAvailable ||
                (isEpin && !selectedEpinAmount) ||
                (!isEpin && !isProductTypeAccessory) ||
                !showDeviceAddError ||
                disableCta
              "
              (onSelect)="addAccessoriesToCart(true)"
              id="tmo-button-check-out"
              >{{ pdpStaticContent?.checkout }}
            </tmo-button>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="isEpin || selectedItemDetails?.length === 0">
        <div class="col-xs-12 p-l-md m-b-md">
          <p class="small">
            <img
              src="{{ pdpStaticContent?.P65WarningImageUrl }}"
              class="alert-img p-r-xs"
              alt="Alert"
            />
            <span class="bold vertical-bottom">{{ pdpStaticContent?.Warning }}: </span>
            <span class="vertical-bottom">{{ pdpStaticContent?.P65WarningMessage }} – </span>
            <a
              href="{{ pdpStaticContent?.p65WarningUrl }}"
              class="vertical-bottom"
              target="_blank"
              >{{ pdpStaticContent?.P65WarningLink }}</a
            >
          </p>
        </div>
      </div>
      <div #ref>
        <ng-content select="[selectCTA]"></ng-content>
      </div>
      <ng-template #displaySelectCta>
        <ng-container *ngIf="ref.children.length === 0">
          <div class="buttons-container-vertical button-spacing">
            <div
              class="button-box"
              *ngIf="
                !isP10MCustomer &&
                isAuthFlow &&
                !isUpgradeCart &&
                (isCartEmpty || isPurchaseEquipment)
              "
            >
              <button
                class="btn btn-primary"
                [disabled]="!showDeviceAddError || !isProductAvailable"
                (click)="checkDeviceError(deviceDetails, true, true)"
                id="upgrade_device"
              >
                {{ pdpStaticContent?.upgradeExistingLine }}
              </button>
            </div>
            <div
              class="button-box"
              *ngIf="!isP10MCustomer && isAuthFlow && isUpgradeCart && !isEditingNonLineDevice"
            >
              <button
                class="btn btn-primary"
                (click)="checkDeviceError(deviceDetails, true)"
                id="replace_device"
              >
                {{ pdpStaticContent?.replaceDevice }}
              </button>
            </div>
            <div class="button-box" *ngIf="!isUpgradeFlow">
              <button
                class="btn"
                [ngClass]="
                  isAuthFlow && (isCartEmpty || isPurchaseEquipment)
                    ? 'btn-secondary'
                    : 'btn-primary'
                "
                [attr.aria-label]="pdpStaticContent?.select"
                (click)="checkDeviceError(deviceDetails, false)"
                id="btn-default-2"
                [disabled]="!isProductAvailable || !showDeviceAddError"
              >
                <div *ngIf="isAuthFlow && (isCartEmpty || isPurchaseEquipment); else Other">
                  {{ pdpStaticContent?.addNewLine }}
                </div>
                <ng-template #Other> {{ pdpStaticContent?.select }}</ng-template>
              </button>
            </div>
            <div class="button-box">
              <button
                class="btn btn-secondary"
                *ngIf="isAuthFlow && isUpgradeFlow && !isEditingNonLineDevice"
                (click)="postDeviceAsNonLineItem()"
                id="btn-default-4"
              >
                {{ pdpStaticContent?.buyStandaloneDevice }}
              </button>
            </div>
            <div class="button-box" *ngIf="isAuthFlow && isEditingNonLineDevice">
              <button
                class="btn btn-secondary"
                (click)="postDeviceAsNonLineItem()"
                id="btn-default-5"
              >
                {{ pdpStaticContent?.replaceDevice }}
              </button>
            </div>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </div>
  <div class="row" *ngIf="!isEpin">
    <div class="col-12">
      <hr class="divider" />
    </div>
  </div>
</ng-container>
<tmo-spinner [setDelay]="!showSpinner && !existingLineDetailsAvailable"></tmo-spinner>
<tmo-popup *ngIf="showItemAddedPopUp" [message]="pdpStaticContent?.itemAddedToCart"></tmo-popup>
<tmo-device-error-modal
  pdlPageComponentId="deviceError-modal"
  [modal]="deviceErrorModal"
  [deviceDetail]="deviceDetails"
  [aemContent]="pdpStaticContent"
></tmo-device-error-modal>
<tmo-upgrade-multiline-modal
  pdlPageComponentId="upgradeMultiline-modal"
  [displayModal]="displayUpgradeMultilineModal"
  [aemContent]="pdpStaticContent"
  [lineDetails]="cartExistingLines"
  (closeMultilineUpgradeModal)="closeUpgradeModal()"
  (onSelectUpgradeLine)="updateUpgradeLineSelected(deviceDetails, true)"
></tmo-upgrade-multiline-modal>
<tmo-static-modal
  pdlPageComponentId="product-offering-static-modal"
  [modal]="mixedCartModal"
  (onSelect)="handleClickEvent($event)"
></tmo-static-modal>
